import { type FC } from 'react';

import { Link } from 'react-router-dom';

import { CATALOG_CATEGORIES } from '@entities/catalog';
import { LEGAL_DOCS } from '@entities/legal';
import { COMPANY } from '@shared/config';
import { Logo, LOGO_HOME_LABEL } from '@shared/ui/Logo';

import styles from './SiteFooter.module.css';

// Только открытые разделы: новый раздел каталога появится в подвале сам
const FOOTER_CATEGORIES = CATALOG_CATEGORIES.filter((c) => !c.isComingSoon);

// В узком столбике телефона адрес переносится только после города: «ул. Зверева, 22» не рвётся
const FOOTER_ADDRESS = COMPANY.address.replace(/ул\. /, 'ул. ').replace(/, (\d+)$/, ', $1');

/** Подвал: компания · каталог · контакты, ниже — реквизиты и документы */
export const SiteFooter: FC = () => {
  return (
    <footer className={styles.root}>
      <div className={styles.inner}>
        <div className={styles.main}>
          <div className={styles.brand}>
            <Link className={styles.logoLink} to="/" aria-label={LOGO_HOME_LABEL}>
              <Logo />
            </Link>
            <p className={styles.tagline}>
              Уличное спортивное оборудование и металлоконструкции на заказ
            </p>
          </div>

          <nav className={styles.group} aria-label="Каталог">
            <h2 className={styles.heading}>Каталог</h2>
            <ul className={styles.linkList}>
              {FOOTER_CATEGORIES.map((c) => (
                <li key={c.id}>
                  <Link className={styles.navLink} to={`/catalog/${c.slug}`}>
                    {c.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className={styles.group}>
            <h2 className={styles.heading}>Контакты</h2>
            {/* address — семантика контактов владельца сайта; заголовки внутри него запрещены */}
            <address className={styles.contacts}>
              <a className={styles.contactLink} href={COMPANY.phoneHref}>
                {COMPANY.phone}
              </a>
              <a className={styles.contactLink} href={`mailto:${COMPANY.email}`}>
                {COMPANY.email}
              </a>
              <span>{FOOTER_ADDRESS}</span>
            </address>
          </div>
        </div>

        {/* Документы → реквизиты; на ПК реквизиты уходят влево, на телефоне год — последней строкой */}
        <div className={styles.bottom}>
          <div className={styles.docs}>
            <Link className={styles.docLink} to={LEGAL_DOCS.privacy.path}>
              {LEGAL_DOCS.privacy.title}
            </Link>
          </div>
          <div className={styles.requisites}>
            <span className={styles.copyright}>
              © {new Date().getFullYear()} {COMPANY.brand}
            </span>
            <span>{COMPANY.operatorShort}</span>
            <span>ИНН {COMPANY.inn}</span>
            <span>ОГРНИП {COMPANY.ogrnip}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
